import { createPermission, hasPermission } from '../../config/accessControl';
import { useAuth } from '../../context/AuthContext';

function PermissionGate({ resource, action, permission, fallback = null, children }) {
  const { user } = useAuth();
  const requiredPermission = permission || createPermission(resource, action);

  return hasPermission(user, requiredPermission) ? children : fallback;
}

export default PermissionGate;
